import { IBitfApiCallState } from '@interfaces';
import { BitfGraphQlApiCallStateMapper } from '@common/libs/bitforce/core/api-call-state/bitf-graph-ql-api-call-state';

export class DefaultApiCallStateMapper extends BitfGraphQlApiCallStateMapper {}
